(function () {
    'use strict';

    angular
        .module('ib-reusable-module')
        .directive('ibIberiaPayScript', ibIberiaPayScript);

    /* istanbul ignore next */
    ibIberiaPayScript.$inject = ['$document', '$compile', '$sce', '$rootScope'];
    function ibIberiaPayScript($document, $compile, $sce, $rootScope) {
        // Usage: ibIberiaPay
        //
        // Creates: inject script iberia pay
        //
        var directive = {
            restrict: 'E',
            link: link
        };
        return directive;

        function link($scope) {
            var script, url = $rootScope.production ? 'https://pay-iberia-pci.indra-netplus.com/iberiapay/js/ibdc-2.0.0.js' : 'https://www.test.indra-netplus.com/iberiapay/js/ibdc-2.0.0.js';
            script = '<script type="text/javascript" src="' + $sce.trustAsResourceUrl(url) + '"></script>';
            angular.element($document).find('head').append($compile(script)($scope));
        }
    }

})();